import merge from 'lodash/merge'
import { parseResponsiveProperty } from '@converdy/styles'

import { breakpoints, breakpointsMedia, breakpointsMediaInversed } from '@converdy/styles'

export default ({
  swipeable,
  spacing,
  columns,
  dots,
  arrows,
  dotColor,
  dotActiveColor,
  dotSize,
  dotPosition,
  arrowColor,
  arrowActiveColor,
  arrowSize,
  arrowPosition,
  arrowBgSize,
  arrowBg,
}) => {

  const ITEM_SELECTOR = '& .grid:not(.converdy-swipable) .item'
  
  let {desktop: desktopColumns, tablet: tabletColumns, mobile: mobileColumns} = columns
  let {desktop: desktopSwipeable, tablet: tabletSwipeable, mobile: mobileSwipeable} = swipeable

  // Column inheritance
  tabletColumns = typeof tabletColumns === 'undefined' ? desktopColumns : tabletColumns
  mobileColumns = typeof mobileColumns === 'undefined' ? tabletColumns : mobileColumns

  // Swipeable inheritance
  tabletSwipeable = typeof tabletSwipeable === 'undefined' ? desktopSwipeable : tabletSwipeable
  mobileSwipeable = typeof mobileSwipeable === 'undefined' ? tabletSwipeable : mobileSwipeable
  
  let jss = {
    '&': {
      ...merge(
        parseResponsiveProperty('--dot-color', dotColor),  
        parseResponsiveProperty('--dot-active-color', dotActiveColor),  
        parseResponsiveProperty('--arrow-color', arrowColor),  
        parseResponsiveProperty('--arrow-active-color', arrowActiveColor),  
        parseResponsiveProperty('--dot-size', dotSize),  
        parseResponsiveProperty('--dot-position', dotPosition),  
        parseResponsiveProperty('--arrow-position', arrowPosition),  
        parseResponsiveProperty('--arrow-size', arrowSize),  
        parseResponsiveProperty('--arrow-bg-size', arrowBgSize),  
        parseResponsiveProperty('--arrow-bg', arrowBg),  
        // parseResponsiveProperty((c) => ({
        //   '--dot-size': `${c}px` 
        // }), dotSize)
      ),   
    },
    '& .grid:not(.converdy-swipable)': {
      display: 'grid',
      ...merge(
        parseResponsiveProperty((c) => ({
          'gridGap': `${c}px` 
        }), spacing),  
        parseResponsiveProperty((c) => {
          return {'gridTemplateColumns': `repeat(${Number(c)}, 1fr)`}
        }, columns)  
      ),        
    },
    "& .sg-dots": parseResponsiveProperty((c) => ({
      'display': c ? 'flex' : 'none' 
     }), dots),
    "& .sg-arrow": parseResponsiveProperty((c) => ({
      'display': c ? 'flex' : 'none' 
     }), arrows)
  }

  if(desktopSwipeable === true) {
    merge(jss, {
      [breakpointsMediaInversed.tablet]: {
        [`${ITEM_SELECTOR}:nth-child(n+${desktopColumns + 1})`]: {
          display: 'none'
        }
      }
    })
  } else {
    merge(jss, {
      [breakpointsMediaInversed.tablet]: {
        "& .sg-dots, & .sg-arrow": {
          display: 'none !important'
        }
      }
    })
  }

  if(tabletSwipeable === true) {
    merge(jss, {
      [`${breakpointsMediaInversed.mobile} and (max-width: ${breakpoints.tablet}px)`]: {
        [`${ITEM_SELECTOR}:nth-child(n+${tabletColumns + 1})`]: {
          display: 'none'
        }
      }
    })
  } else {
    merge(jss, {
      [`${breakpointsMediaInversed.mobile} and (max-width: ${breakpoints.tablet}px)`]: {
        "& .sg-dots, & .sg-arrow": {
          display: 'none !important'
        }
      }
    })
  }

  if(mobileSwipeable === true) {
    merge(jss, {
      [breakpointsMedia.mobile]: {
        [`${ITEM_SELECTOR}:nth-child(n+${mobileColumns + 1})`]: {
          display: 'none'
        }
      }
    })
  } else {
    merge(jss, {
      [breakpointsMedia.mobile]: {
        "& .sg-dots, & .sg-arrow": {
          display: 'none !important'
        }
      }
    })
  }

  return jss
}
